import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { OptionService } from 'src/app/options/option.service';
import { Users } from 'src/app/options/users/users.model';
import { Globle } from 'src/assets/globle';
import { CategoryPermission } from './categoryPermission.model';
import { CategorypermissionService } from './categorypermission.service';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-category-permission',
  templateUrl: './category-permission.component.html',
  styleUrls: ['./category-permission.component.css']
})
export class CategoryPermissionComponent implements OnInit {

  users: Users[] = [];
  lstCategories: CategoryPermission[] = [];
  permission: CategoryPermission = {} as CategoryPermission;
  displayedColumns: string[] = ['category', 'view'];
  dataSource!: MatTableDataSource<CategoryPermission>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  selectedRole!: string;
  selectedMenu!: number;
  pageSize = 100;

  filteredOptions!: Observable<Users[]>;
  searchCategory = new FormControl();
  selectedUser!: string;
  constructor(private translate: TranslateService,
    private optionService: OptionService,
    private service: CategorypermissionService,
    private globle: Globle,
    private localStorage: LocalStorageService,
    private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.pageSize = this.globle.pageSize;
    this.getUsers();
  }

  getUsers() {
    let userId = this.localStorage.retrieve("userInfo").userId
    this.optionService.getAllCustomers(userId).subscribe(data => {
      this.users = data
      this.autoCompleatFilter();
    }, error => {
      console.log(error)
    })
  }

  autoCompleatFilter() {
    this.filteredOptions = this.searchCategory.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.users.slice())
      );
  }

  private _filter(name: string): Users[] {
    const filterValue = name.toLowerCase();

    return this.users.filter(option => option.fullName.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(user: Users): string {
    return user && user.fullName ? user.fullName : '';
  }

  selectUserChange(value: any) {
    this.selectedUser = value.id;
    this.getData();
  }

  getData() {
    this.spinnerOverlay = true;

    this.service.getByUser(this.selectedUser).subscribe(data => {
      this.lstCategories = data;
      this.dataSource = new MatTableDataSource(this.lstCategories);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    });
  }

  save() {
    this.spinnerOverlay = true;
    var _categoryIds = [];
    for (var i = 0; i < this.lstCategories.length; i++) {

      if (!this.lstCategories[i].userPermission) {

        _categoryIds.push(this.lstCategories[i].categoryId);
      }
    }

    var obj = {
      userId: this.selectedUser,
      categoryIds: _categoryIds
    }

    this.service.Create(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      if (error.error.message != undefined) {
        this.openSnackBar(error.error.message, 'snackBarError');
      }
      else {
        this.openSnackBar("Internal server error", 'snackBarError');
      }
    })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }
}
